'use strict';

import config from '../config';

export default config;



// WEBPACK FOOTER //
// ./app/src/services/config.js